/**
 * CRA API base for Cloud Run. Matches SeaWolfSolver fallback when REACT_APP_API_URL
 * is unset (e.g. misconfigured preview build).
 */
export const COGNIDOOR_API_BASE_FALLBACK =
  'https://cognidoor-backend-92219505867.us-east1.run.app';

let sameHostMisconfigLogged = false;

/**
 * Optional Vercel/CI build stamp (e.g. `git rev-parse --short HEAD` at build time).
 * Set `REACT_APP_GIT_SHA` in the frontend build env; surfaced in OwnerOnlyRoute ?debug=1.
 */
export function getCognidoorBuildStamp() {
  const v = process.env.REACT_APP_GIT_SHA;
  return typeof v === 'string' && v.trim() !== '' ? v.trim() : null;
}

export function getCognidoorApiBase() {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim() !== '') {
    const trimmed = fromEnv.trim().replace(/\/$/, '');
    if (typeof window !== 'undefined') {
      try {
        const envHost = new URL(trimmed).hostname;
        if (envHost === window.location.hostname) {
          if (!sameHostMisconfigLogged) {
            console.error(
              '[getCognidoorApiBase] REACT_APP_API_URL points at this page\'s host; Express API lives on Cloud Run. Using COGNIDOOR_API_BASE_FALLBACK instead.'
            );
            sameHostMisconfigLogged = true;
          }
          return COGNIDOOR_API_BASE_FALLBACK;
        }
      } catch (_) {
        /* ignore invalid REACT_APP_API_URL */
      }
    }
    return trimmed;
  }
  return COGNIDOOR_API_BASE_FALLBACK;
}
